/* RK v2 parent map loader (2026-10-01). The map lives in Shopify Files (Content > Files: rk-parents-map-2026-10-01.js) so it can be refreshed with fileUpdate, without any theme edit. The ?d= stamp changes once a day so browsers/CDN pick up a refreshed map within a day. */
(function(){
  var d=new Date(),stamp=''+d.getUTCFullYear()+(d.getUTCMonth()+1)+d.getUTCDate();
  var MAP='/cdn/shop/files/rk-parents-map-2026-10-01.js?d='+stamp;
  function rerunGroups(){
    if(document.documentElement.classList.contains('rkv2-grouped'))return;
    var g=document.querySelector('script[src*="rk-v2-groups"]');
    if(g){var n=document.createElement('script');n.src=g.src;document.head.appendChild(n);}
  }
  var s=document.createElement('script');s.src=MAP;s.onload=rerunGroups;document.head.appendChild(s);
  /* CWV: product-card hover (second) images carry data-rk-src instead of data-src, so the theme's on-load unveil cannot fetch them. They are switched on only for devices that can hover. */
  window.RKV2_HOVER=function(){
    if(!(window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine)').matches))return;
    document.querySelectorAll('img.rk-hover-lazy[data-rk-src]').forEach(function(i){
      i.setAttribute('data-src',i.getAttribute('data-rk-src'));
      i.setAttribute('data-srcset',i.getAttribute('data-rk-srcset')||'');
      i.removeAttribute('data-rk-src');i.classList.remove('rk-hover-lazy');i.classList.add('lazyload');
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',window.RKV2_HOVER);else window.RKV2_HOVER();
  document.addEventListener('shopify:section:load',window.RKV2_HOVER);
})();
